import React from "react";
import {CircularProgress, Stack,} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import MLHostGpu from "./MLHostGpu";
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";


class MLHostDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            mlhost: null,
        };
    }

    async componentDidMount() {
        await this.reload();
    }

    async reload(){
        await this.retrieveMLHost();
        await this.retrieveGpus();
        this.timer = setInterval(
            this.retrieveGpus.bind(this),
            2000
        );
    }

    componentWillUnmount() {
        if (this.timer){
            clearInterval(this.timer);
        }
    }

    async retrieveMLHost(){
        await this.setState(
            {
                mlhost: null,
            }
        );
        const api = new BaseApi();
        let url = `mlhost/${this.props.params.mlhostId}/`
        let response = await api.get(url, {});
        await this.setState(
            {
                mlhost: response.data
            }
        );
    }

    async retrieveGpus(){
        const api = new BaseApi();
        let url = `mlhost/${this.props.params.mlhostId}/gpus/`
        let response = await api.get(url, {});
        await this.setState(
            {
                gpus: response.data
            }
        );
    }

    render() {
        if (!this.state.mlhost){
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={2}
                sx={{
                    width: '100%'
                }}
            >
                <Stack
                    direction={'row'}
                    spacing={1}
                >
                    <Typography
                        level="body-lg"
                    >
                        # {this.state.mlhost.id} - {this.state.mlhost.title}
                    </Typography>
                </Stack>
                <Card>
                    <CommonInfoTab
                        callBack={this.retrieveMLHost.bind(this)}
                        groups={[
                            {
                                title: 'Настройки',
                                icon: <PrecisionManufacturingIcon/>,
                                fields: [
                                    {
                                        title: 'URL Сервера',
                                        value: this.state.mlhost.url,
                                        edit: {
                                            permission: true,
                                            fields: ['url', ],
                                            baseUrl: 'mlhost',
                                            obj: this.state.mlhost
                                        },
                                    },
                                    {
                                        title: 'URL Инференса',
                                        value: this.state.mlhost.inference_url,
                                        edit: {
                                            permission: true,
                                            fields: ['inference_url', ],
                                            baseUrl: 'mlhost',
                                            obj: this.state.mlhost
                                        },
                                    },
                                    {
                                        title: 'URL Распознавания речи',
                                        value: this.state.mlhost.voice_url,
                                        edit: {
                                            permission: true,
                                            fields: ['voice_url', ],
                                            baseUrl: 'mlhost',
                                            obj: this.state.mlhost
                                        },
                                    },
                                    {
                                        title: 'URL информации о GPU',
                                        value: this.state.mlhost.gpu_url,
                                        edit: {
                                            permission: true,
                                            fields: ['gpu_url', ],
                                            baseUrl: 'mlhost',
                                            obj: this.state.mlhost
                                        },
                                    },
                                    {
                                        title: 'Token',
                                        value: this.state.mlhost.token,
                                        edit: {
                                            permission: true,
                                            fields: ['token', ],
                                            baseUrl: 'mlhost',
                                            obj: this.state.mlhost
                                        },
                                    },
                                    {
                                        title: 'Системный промпт',
                                        value: this.state.mlhost.system_prompt,
                                        edit: {
                                            permission: true,
                                            fields: ['system_prompt', ],
                                            baseUrl: 'mlhost',
                                            obj: this.state.mlhost
                                        },
                                        md: 12,
                                        lg: 12,
                                    },
                                ]
                            },
                        ]
                        }
                    />
                </Card>

                <Stack
                    direction={'row'}
                    spacing={1}
                    useFlexGap
                    sx={{ flexWrap: 'wrap' }}
                >
                    {
                        this.state.gpus?
                            this.state.gpus.map(
                                e => <MLHostGpu gpu={e} key={'MLHostGpu' + crypto.randomUUID()}/>
                            ):
                            null
                    }
                </Stack>

            </Stack>
        )
    }
}

export default withRouter(MLHostDetail);
